"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lexemes = require('./config/lexemes');
function lexemesArrayToBinaryTree(options, lexemesArray) {
    let i = 0;
    function createTree(end, newI) {
        let tree = {};
        if (newI) {
            i = newI;
        }
        while (lexemesArray[i] && lexemesArray[i].type !== end) {
            if (!lexemes[lexemesArray[i].type].syntaxer) {
                throw new Error('Unexpected token ' + lexemesArray[i].type);
            }
            let temp = lexemes[lexemesArray[i].type].syntaxer(options, lexemesArray, i, tree, createTree);
            if (temp) {
                i = temp;
            }
        }
        if (end && !lexemesArray[i]) {
            throw new Error('Bad end of block');
        }
        else if (end) {
            i += 1;
        }
        return tree;
    }
    return createTree(null);
}
exports.lexemesArrayToBinaryTree = lexemesArrayToBinaryTree;
